import { render, staticRenderFns } from "./ReferenceFactTypeManager.vue?vue&type=template&id=398156e8&scoped=true"
import script from "./ReferenceFactTypeManager.vue?vue&type=script&lang=js"
export * from "./ReferenceFactTypeManager.vue?vue&type=script&lang=js"
import style0 from "./ReferenceFactTypeManager.vue?vue&type=style&index=0&id=398156e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398156e8",
  null
  
)

export default component.exports